import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'
import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'

import messages from './messages'
import s from './QuizStartModal.scss'


class QuizStartModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.QuizStart,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        className={s.quizStartModal}
        name={name}
        title={messages.title}
        onClose={this.handleClose}
        showCloseButton={false}
        titleUppercase
      >
        <FormattedMessage
          tag="p"
          className={s.text}
          {...messages.text}
        />
        <div className={s.buttonContainer}>
          <Button
            title={messages.buttonText}
            onClick={this.handleClose}
            brand
            fullWidth
          />
          <VisuallyHidden>
            <button
              onClick={this.handleClose}
              type="button"
            >
              Close modal
            </button>
          </VisuallyHidden>
        </div>
      </Modal>
    )
  }
}


export default QuizStartModal
